<template>
	<dl>
		<dt>{{ field.label }}</dt>
		<dd>
			<FieldInput
				:disabled="field.readonly || disabled"
				:field="field"
                :value="readFieldFlat(record, field.field)"
                :record="record"
				@input="onInput"
			/>
		</dd>
	</dl>
</template>

<script>
import FieldInput from '@/components/FieldInput'
import { readFieldFlat } from '@/util'

export default {
	props: ['disabled', 'record', 'field'],
	components: { FieldInput },
	methods: {
		readFieldFlat,
		onInput(value) {
			this.$emit('change', Object.assign({ value }, this.field))
		},
	},
}
</script>
